import { AddressDisplay } from "./AddressDisplay";
import { AnzsicDisplay } from "kw/util/DisplayRegistry/AnzsicDisplay";
import { BooleanDisplay } from "./BooleanDisplay";
import { CurrencyDisplay } from "./CurrencyDisplay";
import { DateDisplay } from "./DateDisplay";
import { FileUploadDisplay } from "./FileUploadDisplay";
import { FormListDisplay } from "./FormListDisplay";
import { InputRegistry } from "kanopi-components/InputRegistry";
import { ListDisplayInput } from "./ListDisplayInput";
import { RadioButtonDisplay } from "./RadioButtonDisplay";
import { StringDisplay } from "./StringDisplay";
import { TimeDisplay } from "./TimeDisplay";

export enum DisplayRegistryList {
  Address = "address",
  RadioButton = "radio-button",
  CardSelect = "card-select",
  Boolean = "boolean",
  Date = "date",
  Currency = "currency",
  Select = "select",
  ListDisplay = "list-display",
  Checkbox = "checkbox",
  String = "string",
}

export const displayRegistry = new InputRegistry({
  address: AddressDisplay,
  "radio-button": RadioButtonDisplay,
  "card-select": RadioButtonDisplay,
  boolean: BooleanDisplay,
  date: DateDisplay,
  time: TimeDisplay,
  currency: CurrencyDisplay,
  select: RadioButtonDisplay,
  "list-display": ListDisplayInput,
  "form-list": FormListDisplay,
  checkbox: BooleanDisplay,
  string: StringDisplay,
  "file-upload": FileUploadDisplay,
  "anzsic-code": AnzsicDisplay,
  "payment-frequency": StringDisplay,
});
